/**
 * Metadata a client needs to know to upload files to the API.
 */
export interface AuthorizedUploadIntent {
  uuid: string;
  method: string;
  url: string;
  headers: Record<string, string>;
}

/**
 * Must match backend AttachmentUploadIntentStatus. See that class for details
 * on each status.
 */
export enum AttachmentUploadIntentStatus {
  Created = 'created',
  Authorized = 'authorized',
  Complete = 'complete',
  ErrorAtCreation = 'error_at_creation',
  ErrorAtReception = 'error_at_reception',
  ErrorInProcessing = 'error_in_processing',
}

export interface SubmitNewPhotoResult {
  success: boolean;
  error?: string;
}

/**
 * Details about a newly selected Photo file from our Add or Select Existing
 * Photo Modal.
 */
export interface SelectedPhoto {
  batchId: string; // UUID
  error: string;
  file: File;
  filename: string;
  photoDate: string; // YYYY-MM-DD
  uploadProgress: number;
}
